export const callRpc = (db, fnPath, params) => {
  const parts = fnPath.split('.');
  return parts.length === 2
    ? db.schema(parts[0]).rpc(parts[1], params)   // schema + func
    : db.rpc(fnPath, params);                     // public.schema
};
